import styled from "styled-components";

export const Container = styled.section`
  width: 100%;
  margin: 0 auto;

  .custom_prev_n {
    left: -12% !important;
  }
  .custom_next_n {
    right: -12% !important;
  }
  @media (max-width: 991px) {
    .custom_prev_n {
      left: -20% !important;
    }
    .custom_next_n {
      right: -20% !important;
    }
  }
  @media (max-width: 575px) {
    .custom_prev_n {
      display: none;
    }
    .custom_next_n {
      display: none;
    }
  }
`;

export const TopWrapper = styled.div`
  margin: 50px 0 10px 0;
  padding: 0px !important;
`;

export const SliderWrapper = styled.div`
  width: 85%;
  background-color: #fff;
  overflow: hidden;
  border: 1px solid #ececec;
  border-radius: 15px;
  margin-bottom: 30px;
  position: relative;
  @media (max-width: 1200px) {
    width: 100%;
  }

  .mainImg {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    width: 100%;
    & img {
      min-width: 100%;
    }
  }

  .subImg {
    width: 100%;
    overflow: hidden;
    cursor: pointer;
    z-index: 1000;
    max-height: 8rem;
  }

  .swiper-slide {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }

  .mySwiper {
    padding: 0 10px;
    margin-bottom: 10px;
    box-sizing: border-box;
    .swiper-slide {
      opacity: 0.7;
    }
  }

  .mySwiper .swiper-slide-thumb-active {
    opacity: 1;
    border: 1px solid #ececec;
    border-radius: 5px;
  }
`;

// 상단 상품정보
export const DetailInfo = styled.div``;

// 제목
export const HeaderWrapper = styled.div`
  position: relative;

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
  }

  .title-wrapper {
    word-break: keep-all;
    margin-right: 80px;
    margin-bottom: 20px;

    & h4 {
      margin-bottom: 10px;
    }
    & span {
      font-size: 16px;
    }

    @media (max-width: 1024px) {
      margin-right: 0;
    }
  }

  .share-wish-wrapper {
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    align-items: center;
    gap: 0.4rem;

    .action-btn {
      cursor: pointer;
      border: 1px solid #f1f1f1;
      border-radius: 100%;
      display: inline-block;
      width: 30px;
      height: 30px;
      padding: 1rem;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all 0.5s ease-out 0s;
      -webkit-transition: all 0.5s ease-out 0s;
      font-size: 22px;

      .msg-tooltip {
        width: 350%;
        left: -120%;
        word-break: keep-all;
        text-align: center;
      }

      @media (max-width: 1024px) {
        font-size: 18px;
        padding: 0.8rem;

        .msg-tooltip {
          padding: 6px;
        }
      }
    }

    @media (max-width: 1024px) {
      position: static;
    }
  }

  @media (min-width: 767px) and (max-width: 1024px) {
    display: flex;
    flex-direction: column;
  }
`;

// 가격
export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.totalPrice ? "column" : "row")};
  align-items: start;
  margin-top: 10px;
  border-top: 1px solid #ececec;
  padding-top: 20px;
  padding-bottom: 12px;

  .pricebox-top {
    display: flex;
    width: 100%;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.75rem;
    margin-bottom: 1rem;

    @media (max-width: 767px) {
      flex-direction: column; // 모바일에서는 세로로 정렬
      align-items: flex-start;
    }
  }

  .pricebox-bottom {
    display: flex;
    width: 100%;
    margin-top: 6px;
  }

  .title {
    font-size: 16px;
    margin-right: 10px;
    margin-top: auto;
    margin-bottom: auto;
    min-width: 100px;
    color: #696969;
  }

  .qty-wrapper {
    margin: auto 0;

    .detail-qty {
      margin: 0 5px 0 0;
      background: #fff;
      border: 2px solid #3bb77e !important;
      font-size: 16px;
      font-weight: 700;
      color: #3bb77e;
      border-radius: 5px;
      padding: 11px 44px 11px 28px;
      width: 22%;
    }
  }

  .price {
    margin: auto 0 auto auto;
    /* margin-top: auto;
    margin-left: auto; */
  }

  .no-saleper-price {
    margin-top: auto;
    margin-bottom: 12.5px;
    margin-left: auto;
  }

  .old-price {
    width: 100%;
    display: flex;
    margin-bottom: 10px;
    @media screen and (max-width: 960px) {
      justify-content: flex-end;
    }
  }

  .discount_price {
    display: flex;
    justify-content: end;
    font-size: 28px;
    font-weight: 600;
    padding-bottom: 2px;
    @media screen and (max-width: 460px) {
      font-size: 24px;
    }
    @media screen and (max-width: 350px) {
      font-size: 20px;
    }
  }
  margin-bottom: 10px;
`;

export const OldPrice = styled.span`
  text-decoration: line-through;
  color: #b6b6b6;
  font-size: 18px;
  font-weight: 700;
  display: block;
`;

export const SalePer = styled.span`
  font-weight: 600;
  display: block;
  color: #e74c3c;
  font-size: 20px;
  margin-right: 10px;
`;

export const DiscountPrice = styled.span`
  font-size: 35px;
  text-decoration: none;
  font-weight: 700;
  margin-bottom: 10px;
  @media screen and (max-width: 960px) {
    font-size: 30px;
    width: 100%;
    text-align: end;
  }
  @media screen and (max-width: 350px) {
    font-size: 24px;
  }
`;

export const PointBox = styled.div`
  width: fit-content;
  display: flex;
  align-items: center;
  font-size: 13px;
  border-radius: 15px;
  position: relative;
  margin-left: auto;

  .infoIcon {
    width: 7px;
    height: 7px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #7e7e7e;
    border-radius: 100%;
    padding: 7px;
    font-size: 5px;
    margin-left: 5px;
    cursor: pointer;
    :hover {
      border-color: #3bb77e;
      color: #3bb77e;
    }
  }

  .info {
    text-align: center;
    word-break: keep-all;
  }
`;

export const Sticker = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1rem;
  height: 1rem;
  font-size: 12px;
  color: white;
  background-color: #3bb77e;
  border: 1px solid white;
  border-radius: 1rem;
  margin-right: 5px;
`;

// SoldOut
export const SoldOut = styled.div`
  text-align: center;
  background: #fff;
  border: 2px solid #757575;
  font-size: 16px;
  font-weight: 700;
  color: #757575;
  border-radius: 5px;
  margin-right: 10px;
  padding: 10px;
  max-width: 10rem;
`;

// 버튼 구역
export const BtnWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  border-top: 1px solid #ececec;
  padding-top: 10px;
  margin-bottom: 10px;
  .print-btn {
    margin-top: 10px;
    width: 100%;
    font-weight: 500;
    font-size: 1rem;
  }
`;

export const QtyCheckOutBtnWrapper = styled.div`
  width: 100%;
  display: flex;

  .btnBox {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
    gap: 0.5rem;
  }

  @media (min-width: 767px) and (max-width: 1024px) {
    width: 100%;
    margin-right: 0;
    margin-bottom: 5px;
  }
  @media (max-width: 511px) {
    width: 100%;
    margin-right: 0;
    margin-bottom: 5px;
  }
`;

export const CheckoutBtn = styled.button`
  margin: ${(props) => (props.noMargin ? "" : "0 5px 0 0")};
  width: ${(props) => (props.inquiry === "Y" ? "50%" : "100%")};
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #3bb77e;
  background-color: #3bb77e;
  color: #fff;
  border-radius: 5px;
  word-break: keep-all;
  font-size: 1rem;
  font-weight: 500;

  :hover {
    background-color: #ffc107;
    border-color: #ffc107;
  }

  /* @media (min-width: 767px) and (max-width: 1024px) {
    margin-right: 5px;
    :last-of-type {
      margin-right: 0px;
    }
  }
  @media (max-width: 511px) {
    margin-right: 5px;
    :last-of-type {
      margin-right: 0px;
    }
  } */
`;

export const SubBtn = styled.button`
  margin: 0;
  width: auto;
  min-width: auto;
  padding: 0.5rem 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #7e7e7e;
  background-color: white;
  color: #7e7e7e;
  border-radius: 5px;
  word-break: keep-all;
  font-size: 0.8rem;
  font-weight: 500;
  height: 40px;
  white-space: nowrap;

  :hover {
    background-color: #ffc107;
    border-color: #ffc107;
  }

  @media (max-width: 767px) {
    width: 100%; // 모바일에서는 전체 너비
    font-size: 0.75rem;
  }
`;

export const CartBtn = styled.a`
  position: relative;
  padding: 1px 6px;
  background-color: ${(props) => (props.isStored ? "#FF9E5B" : "#077edc")};
  border: ${(props) =>
    props.isStored ? "2px solid FF9E5B" : "2px solid 077edc"};
  border-radius: 5px;
  display: inline-block;
  width: 50%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  font-weight: 500;
  color: #fff;

  &:hover {
    background: ${(props) => (props.isStored ? "" : "#ffc107")};
    color: #fff;
  }
`;

export const CartTooltip = styled.div`
  position: absolute;
  bottom: 105%;
  width: fit-content;
  border: 1px solid #ececec;
  border-radius: 5px;
  padding: 10px 15px 15px 15px;
  background-color: #fff;
  font-size: 13px;
  color: #333;
  z-index: 999;
  cursor: default;

  .tooltip-msg {
    margin: 8px 0;
  }

  @media (min-width: 992px) and (max-width: 1199px) {
    width: 104%;
  }

  @media (min-width: 767px) and (max-width: 991px) {
    width: 146%;
  }

  @media (max-width: 510px) {
    width: 110%;
    word-break: keep-all;
    padding: 6px 10px;
  }

  .btnWrapper {
    display: flex;
    justify-content: space-between;
    gap: 6px;

    .move-cart {
      background-color: #f97316;
      font-weight: 500;
    }

    .keep-shopping {
      /* border: 2px solid #3bb77e; */

      background-color: #3bb77e;
      font-weight: 500;
    }
  }
`;

export const BtnInfo = styled.div`
  position: absolute;
  left: auto;
  bottom: 110%;
  width: 120%;
  background-color: #fff;
  color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  -webkit-transition: all 0.25s ease 0s;
  transition: all 0.25s ease 0s;
  border: 1px solid #ececec;
  border-radius: 5px;
  padding: 10px 10px;
  -webkit-box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.05);
  z-index: 999;
  display: flex;
  flex-direction: column;

  @media (max-width: 575px) {
    /* width: 100%; */
    left: -10%;
  }
`;

export const SocialPayWrapper = styled.div`
  margin-bottom: 50px;

  .social-payment {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    width: 50%;

    .kakao-btn {
      cursor: pointer;
      width: 90%;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #ffeb00;
      color: #333;
      border-radius: 5px;
      font-size: 16px;
      & img {
        max-width: 70px;
        margin-right: 2px;
      }
    }
    .naver-btn {
      cursor: pointer;
      width: 80%;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #00c13c;
      color: #fff;
      border-radius: 5px;
      font-size: 16px;
      & img {
        max-width: 60px;
        margin-right: 10px;
      }
      transition: 0.3s ease;

      :hover {
        background-color: #ffc107;
        transition: 0.3s ease;
      }
    }
    .pick {
      cursor: pointer;
      border: 1px solid #f1f1f1;
      border-radius: 5px;
      display: inline-block;
      width: 20%;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all 0.3s ease 0s;
      -webkit-transition: all 0.3s ease 0s;
      font-size: 16px;
      margin-left: 5px;
      :hover {
        background-color: #00c13c;
        color: #fff;
      }
    }
    @media screen and (max-width: 511px) {
      .naver-btn {
        width: 80%;
      }
      .pick {
        min-width: 20%;
      }
    }
  }
`;

// comment
export const CommentWrapper = styled.div`
  margin-top: 10px;
  border-top: 1px solid #ececec;
  padding-top: 10px;
  word-break: keep-all;
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid #ececec;
  padding-top: 10px;
  margin-bottom: 10px;
  margin-top: 5px;
`;

export const DeliveryComment = styled.ul`
  font-size: 14px;
  & li {
    color: #253d4e;
  }
`;

export const MakeBtnWrapper = styled.div`
  width: 40%;
  height: 50px;
  display: flex;
`;

export const ProductCommnet = styled.ul`
  margin-top: 5px;
  padding-left: 20px;
  & li {
    list-style: disc;
    color: #253d4e;
  }
`;

// productTab
export const ProductTabWraper = styled.div`
  padding: 0;
  border-top: none;
  padding: 50px 0px;

  .shop_info_tab {
    margin: 30px auto;
  }
`;

export const HtmlWrapper = styled.div`
  max-width: 100%;
  & figure {
    max-width: 100%;
  }
`;

export const NPayModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 10000001;
  width: 100vw;
  height: 100vh;
  display: flex;

  .modal-section {
    width: fit-content;
    margin: auto;
    background-color: white;
    overflow: auto;
    border: none;
    display: flex;
    flex-direction: column;
    border-radius: 20px;
    padding: 30px;
    & > i {
      font-size: 2rem;
      color: black;
      cursor: pointer;
      :hover {
        color: #3bb77e;
      }
    }
    @media (max-width: 767px) {
      padding: 10px;
      width: 75vw;
      left: 25vw;
    }
    @media (max-width: 575px) {
      padding: 10px;
      width: 100vw;
    }
  }

  .modal-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    border: none;
    margin: 0 auto;
    .close_icon {
      cursor: pointer;
      width: 30px;
      margin-left: auto;
    }

    .desc {
      text-align: center;
      margin-bottom: 20px;
      padding: 10px 50px;
      font-size: 1rem;
      color: #7e7e7e;

      & figure {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 400px;
        margin: 0px auto 10px;
      }

      @media (max-width: 575px) {
        padding: 10px 10px;
      }
    }

    .btnWrapper {
      display: flex;
      justify-content: space-between;

      & span {
        cursor: pointer;
        width: 100%;
        border-radius: 10px;
        color: #fff;
        text-align: center;
        padding: 10px 0px;
        :hover {
          opacity: 0.8;
        }
      }
      .confirm {
        background-color: #3bb77e;
        display: flex;
        justify-content: center;
        align-items: center;
        & img {
          width: 50px;
          margin-right: 5px;
        }
      }
      .cancel {
        background-color: #80bdff;
        margin-right: 20px;
      }
    }
    @media (max-width: 767px) {
    }
  }
`;

export const ProductDetailTabs = styled.div`
  position: sticky;
  top: 0px;
  width: 100%;
  display: flex;
  padding: 0px 0px;
  z-index: 9;
`;

export const DetailTab = styled.div`
  width: 100%;
  padding: 20px;
  border: 1px solid #ececec;
  cursor: pointer;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  background-color: ${(props) => (props.active ? "#fff" : "#f6f6f6")};
  color: ${(props) => (props.active ? "#3bb77e" : "#235d4e")};

  :first-of-type {
    border-right: none;
  }
`;

export const OptionProducts = styled.div`
  padding: 30px 0px;
  & table {
    margin-bottom: 0px;
  }
`;
export const CertificationContainer = styled.div`
  width: 100%;
  margin-bottom: 30px;
  //border: 1px solid #ececec;

  border-top: 3px solid #ececec;
  border-bottom: 3px solid #ececec;
  border-left: 1px solid #ececec;
  border-right: 1px solid #ececec;
`;

/* Keep the header with slightly improved spacing */
export const CertificationHeader = styled.div`
  text-align: center;
  padding: 20px 0;
  background-color: #f8f8f8;
  border-bottom: 1px solid #ececec;

  h3 {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 5px;
  }

  p {
    font-size: 16px;
    color: #666;
    margin: 0;
  }
`;

/* Fix the grid to properly display certification items in a row */
export const CertificationGrid = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0;
  margin: 0 auto;

  @media (max-width: 768px) {
    flex-direction: ${(props) => (props.itemCount > 2 ? "row" : "column")};
    align-items: center;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
  }
`;

/* Improve certification item styling */
export const CertificationItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px 10px 25px;
  flex: 1;
  max-width: none;
  position: relative;

  /* Add border-left for items except the first one */
  &:not(:first-child) {
    border-left: 1px solid #ececec;
  }

  /* For mobile, remove left borders and add top borders instead */
  @media (max-width: 480px) {
    &:not(:first-child) {
      border-left: none;
      border-top: 1px solid #ececec;
    }
  }

  .icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
    margin-bottom: 15px;

    img {
      max-height: 100%;
      max-width: 100%;
    }
  }

  .cert-name {
    font-size: 16px;
    font-weight: 500;
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    text-align: center;

    &:before {
      content: "✓";
      display: inline-block;
      margin-right: 5px;
      color: #3bb77e;
    }
  }

  .cert-description {
    font-size: 14px;
    color: #888;
    text-align: center;
  }
`;

/* Update the more button styling */
export const MoreButton = styled.div`
  text-align: center;
  padding: 15px 0;
  border-top: 1px solid #ececec;

  button {
    background: none;
    border: none;
    font-size: 14px;
    font-weight: 600;
    color: #666;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    transition: color 0.3s ease;

    &:hover {
      color: #3bb77e;
    }
  }

  i {
    margin-left: 5px;
  }
`;
